export default "__VITE_ASSET__78aab413__"